module.exports = __webpack_public_path__ + "img/edit-blue-2.e1da2580.svg";